import moment from 'moment';
import { saveAs } from "file-saver";
import * as XLSX from "xlsx-js-style";
import { currencyFormat } from '../../../Utils/formatCurrency';

export const ExportReimbursementToExcel = (dataList, startDate, endDate) => {
    const expandedData = dataList.map((item, index) => {
        const itemNames = item.reimbursement_item?.map(i => `${i.item_name} (Rp ${i.total_submission.toLocaleString()})`).join('\n') || '-';
        const imageLinks = item.reimbursement_image?.map(img => img.image).join('\n') || '-';
        const approvals = item.reimbursement_approval?.map(app =>
            `${app.user?.name || '-'} - ${app.status_approval?.status || '-'} (${moment(app.created_at).format('YYYY-MM-DD HH:mm')})`
        ).join('\n') || '-';

        return {
            No: index + 1,
            'Kode Reimbursement': item.reimbursement_code,
            'Nama Karyawan': item.users?.name || "-",
            'Kode Karyawan': item.users?.users_code || "-",
            'Deskripsi': item.desc,
            'Total (Rp)': currencyFormat(item.total),
            'Status': item.status,
            'Tanggal Dibuat': moment(item.created_at).format('YYYY-MM-DD HH:mm'),
            'Item Reimbursement': itemNames,
            'URL Gambar': imageLinks,
            'Riwayat Approval': approvals,
        };
    });

    const ws = XLSX.utils.json_to_sheet(expandedData, { origin: 'A4' });

    const title = "Daftar Reimbursement Karyawan";
    const dateStr = `Periode: ${moment(startDate).format('DD MMM YYYY')} s/d ${moment(endDate).format('DD MMM YYYY')}`;

    const totalCols = Object.keys(expandedData[0]).length;

    ws['A1'] = {
        t: 's',
        v: title,
        s: { font: { bold: true, sz: 18 }, alignment: { horizontal: "center" } }
    };

    ws['A2'] = {
        t: 's',
        v: dateStr,
        s: { font: { italic: true, sz: 12 }, alignment: { horizontal: "center" } }
    };

    ws['!merges'] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: totalCols - 1 } },
        { s: { r: 1, c: 0 }, e: { r: 1, c: totalCols - 1 } }
    ];

    // Style all cells
    const cellRange = XLSX.utils.decode_range(ws['!ref']);
    for (let R = 4; R <= cellRange.e.r; ++R) {
        for (let C = 0; C <= cellRange.e.c; ++C) {
            const cell_ref = XLSX.utils.encode_cell({ r: R, c: C });
            if (ws[cell_ref]) {
                ws[cell_ref].s = {
                    border: {
                        top: { style: "thin", color: { rgb: "000000" } },
                        bottom: { style: "thin", color: { rgb: "000000" } },
                        left: { style: "thin", color: { rgb: "000000" } },
                        right: { style: "thin", color: { rgb: "000000" } },
                    },
                    alignment: {
                        horizontal: "left",
                        vertical: "top",
                        wrapText: true,
                    }
                };
            }
        }
    }

    // Style header row (row 4)
    Object.keys(expandedData[0]).forEach((key, colIndex) => {
        const cellRef = XLSX.utils.encode_cell({ r: 3, c: colIndex });
        const existingCell = ws[cellRef] || { t: "s", v: key, s: {} };
        existingCell.s = {
            font: { bold: true },
            alignment: { horizontal: "center", vertical: "center", wrapText: true },
            border: {
                top: { style: "thin", color: { rgb: "000000" } },
                bottom: { style: "thin", color: { rgb: "000000" } },
                left: { style: "thin", color: { rgb: "000000" } },
                right: { style: "thin", color: { rgb: "000000" } },
            },
        };
        ws[cellRef] = existingCell;
    });

    // Set column widths
    const colWidths = Object.keys(expandedData[0]).map((key) => {
        let maxLen = key.length;
        expandedData.forEach(row => {
            const val = row[key];
            if (val != null) {
                const len = val.toString().length;
                if (len > maxLen) maxLen = len;
            }
        });
        return { wch: maxLen + 5 };
    });
    ws['!cols'] = colWidths;

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Reimbursement");

    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });
    const buf = new ArrayBuffer(wbout.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < wbout.length; i++) {
        view[i] = wbout.charCodeAt(i) & 0xff;
    }

    const fileName = `Reimbursement_List_${moment(startDate).format('YYYYMMDD')}_${moment(endDate).format('YYYYMMDD')}.xlsx`;
    saveAs(new Blob([buf], { type: "application/octet-stream" }), fileName);
};
